/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json

export { referentialityPlugin, createReferentiality } from './plugins/referentiality-plugin';
export { dataSourceResolver } from './data-source-resolver';
export { DataSourceProvider } from './data-source-provider';
export { useReference } from './hooks/useReference';
export { ADFReferenceTypes } from './types';
export type {
	ADFReference,
	ConnectionLink,
	ExternalObserver,
	ExtensionHandlerWithReferenceFn,
	ReferentialityAPI,
	ReferentialityPlugin,
	ReferentialityPluginOptions,
	LocalId,
	LinkNode,
	NewLinkElement,
} from './types';

export {
	NodeNotFoundError,
	CompatibilityError,
	ConfigurationError,
	InitializeError,
	NotImplementedError,
	UnsupportedTypeError,
	SourceReferenceError,
	TargetReferenceError,
	CyclicReferenceError,
	LocalIdCollisionError,
} from './errors';
